import React from 'react';

const Privacy = () => {
  return (
    <div className="min-h-screen pt-32 md:pt-36">
      <section className="py-16 md:py-24">
        <div className="container">
          <div className="max-w-4xl mx-auto">
            <h1 className="display-large mb-8">Privacy Policy</h1>
            <div className="space-y-6 body-medium">
              <p className="body-large text-[#0C6951]">Effective Date: October 17, 2024

              </p>

              <div>
                <h2 className="heading-2 mb-4">1. Information Collection</h2>
                <p>
                  FITNOVEXA ("we," "us," or "our") collects personal information you provide when you: 
                  use our website, register for services, contact us, or participate in our programs. 
                  This may include your name, email address, phone number, company information, and any 
                  other details you choose to share.
                </p>
              </div>

              <div>
                <h2 className="heading-2 mb-4">2. Use of Information</h2>
                <p className="mb-3">We use your information to:</p>
                <ul className="list-disc pl-6 space-y-2">
                  <li>Provide and improve our services</li>
                  <li>Communicate with you about our offerings</li>
                  <li>Process transactions and provide customer support</li>
                  <li>Send administrative information and service updates</li>
                  <li>Comply with legal obligations</li>
                </ul>
              </div>

              <div>
                <h2 className="heading-2 mb-4">3. Information Sharing</h2>
                <p>
                  We do not sell or rent your personal information. We may share information with service 
                  providers who assist our operations, when required by law, or with your explicit consent.
                </p>
              </div>

              <div>
                <h2 className="heading-2 mb-4">4. Data Security</h2>
                <p>
                  We implement reasonable security measures to protect your information. However, no 
                  internet transmission is completely secure. We cannot guarantee absolute security.
                </p>
              </div>

              <div>
                <h2 className="heading-2 mb-4">5. Your Rights</h2>
                <p>
                  You may request access to, correction of, or deletion of your personal information. 
                  Contact us at info@fitnovexa.com to exercise these rights.
                </p>
              </div>

              <div>
                <h2 className="heading-2 mb-4">6. Contact</h2>
                <p>
                  For privacy questions or concerns, contact us at:<br />
                  Email: info@fitnovexa.com<br />
                  Website: fitnovexa.com
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>);

};

export default Privacy;